<app-state-view class="results-listing" [state]="state">
  <loading-state>
    <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
  </loading-state>
  <empty-state>
    <div class="results-listing__placeholder">
      <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
      <div class="results-listing__placeholder-message">Please enter a search query to perform a search.</div>
    </div>
  </empty-state>
  <error-state>
    <div class="results-listing__placeholder results-listing__placeholder--error">
      <mat-icon class="results-listing__placeholder-icon">warning</mat-icon>
      <div class="results-listing__placeholder-message">
        {{ errorMessage || 'An error occurred performing the search. Please try again later.' }}
      </div>
    </div>
  </error-state>
  <content-state>
    <div class="results-listing__container">
      <div class="results-listing__filter-bar">
        <button #rentalSalesPopoverAnchor="satPopoverAnchor" type="button" class="results-listing__filter"
                [satPopoverAnchorFor]="rentalSalesFiltersPopover" (click)="rentalSalesFiltersPopover.toggle()"
                [class.results-listing__filter--active]="rentalSalesPopoverAnchor.isPopoverOpen()">
          Rentals/Sales Filters
          <mat-icon class="results-listing__filter-arrow">keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <div #rentalSalesListEl *ngIf="rentalSales && rentalSales.length > 0; else placeholder" class="results-listing__list">
        <a class="rental-sales-card"
           #rentalSalesEl *ngFor="let business of rentalSales"
           [class.rental-sales-card--active]="business === activeRentalSales"
           [routerLink]="['/business', business.businessId]"
           (click)="onRentalSalesSelected()"
           (mouseenter)="onRentalSalesHover(business, true)"
           (mouseleave)="onRentalSalesHover(business, false)">
          <div class="rental-sales-card__type-row">
            <span class="rental-sales-card__type">{{ business.categories && business.categories.length ? business.categories.join(' · ') : 'Rentals/Sales' }}</span>
            <span class="rental-sales-card__flag" *ngIf="business.privateRentals"
                  title="Rentals not available to the general public">Rentals not open to the public</span>
          </div>
          <div class="rental-sales-card__main">
            <div class="rental-sales-card__content">
              <h2 class="rental-sales-card__name">{{ business.name }}</h2>
              <div class="rental-sales-card__body">
                <div class="rental-sales-card__text" *ngIf="business.airportName || business.airportIdent">
                  <ng-container *ngIf="business.airportName">{{ business.airportName }}</ng-container><ng-container *ngIf="business.airportName && business.airportIdent"> - </ng-container><ng-container *ngIf="business.airportIdent">({{ business.airportIdent }})</ng-container>
                </div>
                <div class="rental-sales-card__text" *ngIf="business.city || business.stateProvince">
                  {{ business.city }}<ng-container *ngIf="business.city && business.stateProvince">, </ng-container>{{ business.stateProvince }}
                </div>
              </div>
            </div>
            <div class="rental-sales-card__photo" *ngIf="business.thumbnailPhotoPath">
              <img class="rental-sales-card__image" [src]="business.thumbnailPhotoPath" alt="" />
            </div>
          </div>
        </a>
      </div>
      <mat-paginator
        *ngIf="rentalSales && rentalSales.length > 0"
        class="results-listing__pagination"
        [pageIndex]="pageIndex"
        [length]="totalRentalSales"
        [pageSize]="pageSize"
        (page)="onPageChanged($event)">
      </mat-paginator>
    </div>
  </content-state>
</app-state-view>

<ng-template #placeholder>
  <div class="results-listing__placeholder">
    <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
    <div class="results-listing__placeholder-message">
      No results found matching your search criteria. Try reducing the number of filters used in the search.
    </div>
  </div>
</ng-template>


<sat-popover #rentalSalesFiltersPopover horizontalAlign="start" verticalAlign="below" hasBackdrop>
  <div class="results-listing__popover">
    <app-rental-sales-finder-filter-list #rentalSalesFilters [query]="query" [compact]="true"
                                         (filtersChange)="onFiltersChanged()">
    </app-rental-sales-finder-filter-list>
  </div>
</sat-popover>
